import { useMutation } from "@tanstack/react-query";
import { updateModuleStatus } from "../api/updateModuleStatus";
import { invalidateActiveModuleTemplateListQuery } from "../queries/useActiveModuleTemplateList";
import { invalidateModuleTemplatePagedListQuery } from "../queries/useModuleTemplatePagedListQuery";
import { UpdateStatusParams } from "../types";

export const useUpdateModuleTemplateStatusMutation = () => {
  return useMutation({
    mutationFn: async ({ moduleId, status }: UpdateStatusParams) => {
      return await updateModuleStatus(moduleId, status);
    },
    onSuccess: () => {
      invalidateModuleTemplatePagedListQuery();
      invalidateActiveModuleTemplateListQuery();
    },
    onError: (e) => {
      console.error("Error occurred when updating module", e);
    },
  });
};
